import type { FormBillTo } from '@fv/client-types'

import { getCustomsBrokerLocationContext } from '@/utils/shipmentFuncs'

import { billToMapper } from '../billTo/billToFuncs'
import { customsBrokerMapper } from '../customsBroker/brokerFuncs'
import type {
  CustomsBroker,
  FormCustomsBroker,
} from '../customsBroker/brokerTypes'
import type { ShipmentLocationFormModel } from '../shipment-location-form/types'

export function optionalFormBillTo(
  billTo: FormBillTo | ShipmentLocationFormModel,
): ReturnType<typeof billToMapper.formToDTO> | undefined {
  const dto = billToMapper.formToDTO(billTo as FormBillTo)
  if (!Object.entries(dto).some(([k, v]) => !!v && k !== 'country')) {
    return undefined
  }
  return billToMapper.forApiPayload(dto)
}

export function optionalCustomsBrokers(
  customsBrokers: FormCustomsBroker[],
  locations: ShipmentLocationFormModel[],
): CustomsBroker[] | undefined {
  const { location } = getCustomsBrokerLocationContext(locations)
  if (!location) return undefined
  return customsBrokers.map(customsBrokerMapper.formToDTO)
}
